import { MATERIALS_DIALOG as LABELS } from './labels.js';

export default {
  data: [],
  option: {
    menuBtn: true,
    emptyBtn: false,
    submitBtn: false,
    submitSize: 'medium',
    submitText: LABELS.save,
    menuPosition: 'center',
    highlightCurrentRow: true,
    arrow: false,
    multiple: false,
    columnBtn: false,
    refreshBtn: false,
    searchShow: false,
    searchBtn: true,
    searchSpan: 12,
    searchMenuSpan: 12,
    column: [
      {
        label: LABELS.materialNumber,
        prop: 'materialNumber',
        editDisplay: false,
        searchSpan: 12,
        search: true,
        width: 200
      },
      {
        label: LABELS.materialName,
        prop: 'materialName',
        editDisplay: false,
        overHidden: true,
        searchSpan: 12,
        search: true
      },
      {
        label: LABELS.materialDescription,
        prop: 'materialDesc',
        editDisplay: false,
        overHidden: true,
        searchSpan: 12,
        search: true
      },
      {
        label: LABELS.specifications,
        prop: 'materialSpecifications',
        editDisplay: false,
        overHidden: true
      },
      {
        label: LABELS.quantity,
        prop: 'quantity',
        editDisplay: false,
        width: 150
      },
      {
        label: LABELS.units,
        prop: 'baseUnit',
        editDisplay: false,
        width: 100
      },
      {
        label: LABELS.factory,
        prop: 'factory',
        editDisplay: false,
        width: 100
      }
      // {
      //   label: '预估单价',
      //   prop: 'budgetPrice'
      // }
    ]
  },
  page: { total: 0, currentPage: 1, pageSize: 10 }
};
